// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1WS8U","footer":"ReportModalFilter_footer__3AQ6b"};